import React, { useState } from "react";
import "../../iqac.css";
import TopNav from "../../../../../Components/TopNav";
import Navbar from "../../../../../Components/Navbar";
import DropdownNav from "../../../../../Components/DropdownNav";
import Footer from "../../../../../Components/Footer";
import Example from "../../../../../Components/Example";
import ScrollToTop from "react-scroll-to-top";

const IQACMeetings = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [framework, setFramework] = useState(false);
  const [three, setThree] = useState(false);
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className="navbar-area">
        <div className="meet-image">
          <div className="image-cover"></div>
        </div>
      </div>

      {/* This iqac details part */}

      <div className="iqac-details">
        <div className="iqac-header">
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
          <h1 className="iqac-obj-tit">IQAC Meetings</h1>
        </div>
      </div>

      {/* This is the body part of the iqac Objectives */}

      <div className="iqac-obj-det">
        <button
          onClick={() => setIsOpen((e) => !e)}
          style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          IQAC Meetings Details
        </button>
        {isOpen && (
          <div className="ssr-items">
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/iqac/pdf/2017-18%20MoM-1_compressed.pdf"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>2017-2018</h3>
                </a>
              </div>
            </div>
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/iqac/pdf/2018-19%20MoM_compressed.pdf"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>2018-2019</h3>
                </a>
              </div>
            </div>
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/iqac/pdf/2019-20%20MoM_compressed.pdf"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>2019-2020</h3>
                </a>
              </div>
            </div>
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/iqac/pdf/2020-2021%20MoM_compressed.pdf"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>2020-2021</h3>
                </a>
              </div>
            </div>
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/iqac/pdf/Minutes-of-Meeting-2021-2022.pdf"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>2021-2022</h3>
                </a>
              </div>
            </div>
          </div>
        )}

        <button
          onClick={() => setFramework((e) => !e)}
          style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          Action Taken Report
        </button>
        {framework && (
          <div className="ssr-items">
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/iqac/pdf/IQAC%20ATR%202017-2018.pdf"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>2017-2018</h3>
                </a>
              </div>
            </div>
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/iqac/pdf/IQAC%20ATR%202018-2019.pdf"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>2018-2019</h3>
                </a>
              </div>
            </div>
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/iqac/pdf/IQAC%20ATR%202019-2020.pdf"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>2019-2020</h3>
                </a>
              </div>
            </div>
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/iqac/pdf/IQAC%20ATR%202020-2021.pdf"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>2020-2021</h3>
                </a>
              </div>
            </div>
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/iqac/pdf/AT-2021-2022.pdf"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>2021-2022</h3>
                </a>
              </div>
            </div>
          </div>
        )}

        <button
          onClick={() => setThree((e) => !e)}
          style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          Strategic plan
        </button>
        {three && (
          <div className="ssr-items">
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/iqac/pdf/strategic-plans-deployment.pdf"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>Strategic Plans & Deployment</h3>
                </a>
              </div>
            </div>
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/iqac/pdf/short-term-goals-vision.pdf"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>Short Term Goals & Vision 2030</h3>
                </a>
              </div>
            </div>
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/iqac/pdf/Strategic-Plans-2021-22.pdf"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>Strategic Plan 2021-2022</h3>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default IQACMeetings;
